export const UPDATE_TAB = 'UPDATE_TAB' as const;
